export const CHANGE_ACTIVE_KEY = 'CHANGE_ACTIVE_KEY';

export function changeActiveKey(activeKey) {
  return {
    type: CHANGE_ACTIVE_KEY,
    activeKey,
  };
}
